import{chain as e}from"lodash";import{load as t}from"cheerio";const n=(n,r)=>e(n).map(e=>t(e)).map(r).flatten().uniq().value();export{n as extractValuesFromHtml};
//# sourceMappingURL=extract-values-from-html.js.map